import { useState, useEffect } from "react";
import { getQMUserResults } from "./libs/api";
import { useAppContext } from "../../Libs/contextLib";
import { Typography, Box, Card, CardContent } from "@mui/material";
import { QMResultsList } from "./components/QMResultsList";
import { QMResultDetails } from "./components/QMResultDetails";
import { DataCard } from "../../Components/DataCard";
import { QMScore } from "./components/QMScore";
import { QMResult } from "./components/QMResult";

export const QMResultsPage = () => {
	const { currUser } = useAppContext();
	type ReviewData = {
		PK: string;
		SK: string;
		averageScore: number;
		result: string;
		reviewId: string;
		responseDate: string;
		questions: any[];
		agent: string;
	};

	type QMData = ReviewData[];

	const [isLoading, setIsLoading] = useState(true);
	const [data, setData] = useState<null | QMData>(null);
	const [selectedResult, setSelectedResult] = useState<null | ReviewData>(null);

	useEffect(() => {
		getQMUserResults(
			`${currUser.attributes.given_name}${currUser.attributes.family_name}`
		).then((result) => {
			const sortedData = sortResponsesByDate(result);
			setData(sortedData);
			setIsLoading(false);
		});
	}, []);

	const sortResponsesByDate = (data: QMData) =>
		data.sort((a, b) => {
			return parseInt(b.responseDate) - parseInt(a.responseDate);
		});

	const getAverageScore = (data?: ReviewData[]) => {
		if (!data) return "0";
		const total = data.reduce(
			(accumulator, currentItem) => accumulator + currentItem.averageScore,
			0
		);
		const average = (total / data.length).toFixed(2);
		return average;
	};

	const getTotalPasses = (data?: ReviewData[]) => {
		if (!data) return "0";
		const total = data.reduce((accumulator, currentItem) => {
			if (currentItem.result === "Pass") return accumulator + 1;
			return accumulator;
		}, 0);
		return total.toString();
	};

	const getTotalFails = (data?: ReviewData[]) => {
		if (!data) return "0";
		const total = data.reduce((accumulator, currentItem) => {
			if (currentItem.result === "Fail") return accumulator + 1;
			return accumulator;
		}, 0);
		return total.toString();
	};

	const agentName = `${currUser.attributes.given_name} ${currUser.attributes.family_name}`;

	const handleListSelection = (resultItem: ReviewData) => {
		setSelectedResult(resultItem);
	};

	return (
		<Box>
			{isLoading ? (
				<Typography>Loading...</Typography>
			) : (
				<>
					<Box
						sx={{
							margin: "0.5rem 0 0 0",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							gap: "1rem",
						}}
					>
						<Typography variant="h4">
							Hi {agentName} here are your QM Reviews
						</Typography>
						<DataCard
							title={"Average Score"}
							value={getAverageScore(data)}
							rag={parseFloat(getAverageScore(data)) >= 4}
						/>
						<DataCard
							title={"Total Passes"}
							value={getTotalPasses(data)}
							rag={true}
						/>
						<DataCard
							title={"Total Fails"}
							value={getTotalFails(data)}
							rag={false}
						/>
					</Box>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							gap: "1rem",
							margin: "0.5rem",
						}}
					>
						<QMResultsList
							data={data}
							handleListSelection={handleListSelection}
						/>
						<QMResultDetails data={selectedResult} />
					</Box>
				</>
			)}
		</Box>
	);
};
